// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 506) return "static/chunks/506.cee024bd96e052d9.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8426 ? "d0709137" : chunkId) + "-" + {"8254":"f5f2f5e414a23784","8426":"98738fceb716b09e"}[chunkId] + ".js";
};